import { userType } from "src/extensions/utils/DefineTypes";
import { auth } from "src/core";
export class Personal {
    mailKb = -1;
    mailName = "";
    mailPostcode = "";
    mailAdr1 = "";
    mailAdr2 = "";
    mailAdr3 = "";
    userCd = -1;
    userKb = -1;
    keiyakusha = "";
    telephoneNumber = "";
    email = "";
    mmaKb = -1;
    canChangePassword = false;
    bankCd = -1;
    bankName = "";
    bansCd = -1;
    bansName = "";
    kouzaSb = -1;
    kouzaNo = -1;
    kouzaName = "";
    kouzaKana = "";
    nyukyokeiyakuList = [];
    ResultStatus = -1;
    LastSyncDate = "";
    get hasMailAddress() {
        return this.userKb !== userType.Kojin || auth.userInfo.isImpersonation || this.email !== "";
    }
    get hasAddress() {
        return this.mailKb === 1;
    }
    get isMma() {
        return this.mmaKb === 1;
    }
}
